import { Component, inject, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { PageInfoService, PageLink } from "src/app/_metronic/layout";

@Component({
  selector: "app-breadcrumb-custom",
  templateUrl: "./breadcrumb-custom.component.html",
  styleUrl: "./breadcrumb-custom.component.scss",
  standalone: false,
})
export class BreadcrumbCustomComponent implements OnInit {
  @Input() set title(title: string) {
    if (title) {
      this.#pageInfoService.updateTitle(title);
    }
  }
  @Input() set breadCrumb(bc: Array<PageLink>) {
    if (bc.length) {
      this.#pageInfoService.updateBreadcrumbs(bc);
    }
  }
  @Input() type: "title" | "bc" | "both" = "both";

  #pageInfoService = inject(PageInfoService);

  title$: Observable<string>;
  bc$: Observable<Array<PageLink>>;

  ngOnInit(): void {
    this.title$ = this.#pageInfoService.title.asObservable();
    this.bc$ = this.#pageInfoService.breadcrumbs.asObservable();
  }
}
